// @ts-nocheck
import { css, Skeleton, SkeletonProps, styled, Tooltip } from '@mui/material';
import { FC } from 'react';

interface BaseSkeletonProps extends SkeletonProps {
  full_width?: 'true' | undefined;
  tooltip?: string;
}

export const BaseSkeleton: FC<BaseSkeletonProps> = ({
  animation = 'wave',
  variant = 'rectangular',
  ...props
}) => {
  if (props?.tooltip) {
    return (
      <Tooltip title={props.tooltip} style={{ width: '100%' }}>
        <StyledSkeleton animation={animation} variant={variant} {...props} />
      </Tooltip>
    );
  }
  return <StyledSkeleton animation={animation} variant={variant} {...props} />;
};

const StyledSkeleton = styled(Skeleton)<{ full_width: 'true' | undefined }>`
  background-color: var(--Neutrals-N800);
  width: 100px;
  opacity: 0.7;
  border-radius: 5px;
  ${({ full_width }) =>
    full_width === 'true' &&
    css`
      width: 100%;
    `}
`;
